<script>
import { VTab } from 'vuetify/lib/components/VTabs';

export default defineComponent({
  extends: VTab,

  props: {
    ripple: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
